export default "__VITE_ASSET__Dw5f8373__"